export enum LoginMethod {
    LOGIN_METHOD_USERNAME = 'app/login/method/username',
    LOGIN_METHOD_GOOGLE = 'app/login/method/google',
    LOGIN_METHOD_ACTIVE_DIRECTORY = 'app/login/method/active_directory',
    LOGIN_METHOD_IMPERSONATE = 'app/login/method/impersonate'
}